import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useContext } from 'react';
import { Box, Icon, Text, Spinner, Flex } from '@chakra-ui/react';
import { ThemeColorVariable, ThemeFontSizeVariable, ThemeFontVariable, ThemeRadiusVariable, ThemeSpaceVariable, } from '@caspeco/casper-ui-library.base-ui.theme';
import { CheckIcon } from './CheckIcon';
import { TimesIcon } from './TimesIcon';
import { StepContext } from './stepContext';
const getStepCircleSize = (isActiveStep, icon) => {
    switch (true) {
        case isActiveStep:
            return '32px';
        case Boolean(icon):
            return '24px';
        default:
            return '13px';
    }
};
/**
 * Helper used to center align label with the circle element when
 * stepper orientation is 'vertical'.
 */
function getLabelMarginTop(stepCircleSize, isVertical) {
    if (!isVertical)
        return '0px';
    switch (stepCircleSize) {
        case '32px':
            return '4px';
        case '13px':
            return '-6px';
        case '24px':
        default:
            return '0px';
    }
}
function StepCircle() {
    const { isActiveStep, iconColor, color, icon } = useContext(StepContext);
    const circleSize = getStepCircleSize(isActiveStep, icon);
    const iconSize = isActiveStep ? '20px' : '16px';
    return (_jsxs(Box, { backgroundColor: color, borderRadius: "full", w: circleSize, minW: circleSize, h: circleSize, minH: circleSize, display: "flex", alignItems: "center", justifyContent: "center", color: iconColor, children: [icon === 'check' && _jsx(Icon, { as: CheckIcon, boxSize: iconSize }), icon === 'spinner' && _jsx(Spinner, { size: isActiveStep ? 'sm' : 'xs' }), icon === 'times' && _jsx(Icon, { as: TimesIcon, boxSize: iconSize })] }));
}
function VerticalStep() {
    const { showDivider, dividerColor } = useContext(StepContext);
    return (_jsxs(Flex, { direction: "column", alignItems: "center", w: "48px", gap: ThemeSpaceVariable.Small, children: [_jsx(StepCircle, {}), showDivider && (_jsx(Box, { width: "3px", minH: "46px", bg: dividerColor, borderRadius: ThemeRadiusVariable.Small }))] }));
}
function HorizontalStep() {
    const { showDivider, dividerColor } = useContext(StepContext);
    return (_jsxs(Flex, { direction: "row", alignItems: "center", h: "48px", gap: ThemeSpaceVariable.Small, children: [_jsx(StepCircle, {}), showDivider && (_jsx(Box, { w: "100%", h: "3px", bg: dividerColor, borderRadius: ThemeRadiusVariable.Small }))] }));
}
/**
 * Internal usage in Stepper.tsx only. Not to be exposed.
 */
export function Step() {
    const { isActiveStep, orientation, label, icon } = useContext(StepContext);
    const isVertical = Boolean(orientation === 'vertical');
    const stepCircleSize = getStepCircleSize(isActiveStep, icon);
    const labelMarginTop = getLabelMarginTop(stepCircleSize, isVertical);
    const innerLabelElement = typeof label === 'string' ? (_jsx(Text, { mt: labelMarginTop, fontFamily: ThemeFontVariable.SubHeader, fontSize: ThemeFontSizeVariable.Medium, color: ThemeColorVariable.OnBackgroundHeader, fontWeight: "medium", children: label })) : (_jsx(Box, { mt: labelMarginTop, children: label }));
    return (_jsxs(Flex, { w: "100%", h: "100%", direction: isVertical ? 'row' : 'column', children: [isVertical ? _jsx(VerticalStep, {}) : _jsx(HorizontalStep, {}), innerLabelElement] }));
}
//# sourceMappingURL=step.js.map